import { useMemo } from "react"

import { useQuerySchoolTransactionsSchoolData } from "api/reactQuery/queries/teacherAdmin"

import { sortClassOptions } from "./dashboardFormat"

// `school-data` loads on first open, or at once when the URL has ids. Only the field fetches;
// the chips read the same cache, so they never add a request.
const useClassOptions = (fetchWhen = false) => {
  const query = useQuerySchoolTransactionsSchoolData({
    options: { enabled: fetchWhen },
  })
  const classes = query.data?.data.classes
  const options = useMemo(() => sortClassOptions(classes ?? []), [classes])
  return { query, classes, options }
}

export default useClassOptions
